import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { EcommerceModule } from '@unleashed/ecommerce/ecommerce.module';
import { environment } from 'src/environments/environment';
import { NoopGoogleTagManagerService } from '@unleashed/services/common/noop-google-tag-manager.service';
import { GoogleTagManagerService } from 'angular-google-tag-manager';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    EcommerceModule
  ],
  providers: [
    {
      provide: GoogleTagManagerService,
      useClass: environment.production
        ? GoogleTagManagerService
        : NoopGoogleTagManagerService
    },
    ...(environment.production
      ? [{ provide: 'googleTagManagerId', useValue: environment.googleTagManager.id }]
      : [])
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
